import React, { useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
// import ProvisionClause from 'src/components/common/ProvisionClause';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import IndexReferenceType from 'src/models/IndexReferenceType';
import BrineLease from 'src/models/contract_types/BrineLease';
import ExtensionOptionList from '../../ExtensionOptionList';
import ExtensionOption from 'src/models/ExtensionOption';

interface IBrineLeaseGenerationProps extends Partial<Pick<UseFormMethods, 'getValues' | 'setValue' | 'register' | 'errors'>> {
    brineLeaseData: BrineLease;
    measurementTypes: Array<IndexReferenceType>;
    provisionalClauses: Array<IndexReferenceType>;
    isInHanded: boolean;
    totalNet?: number;
    calculateTotal: (measurementTypeId: number, paymentAmount: number, grossAcres: number, measurementTypesList: Array<IndexReferenceType>) => void;
}

const BrineLeaseGeneration = (props: IBrineLeaseGenerationProps) => {
    const [extensionOptions, setExtensionOptions] = useState<Array<ExtensionOption>>([]);

    useEffect(() => {
        if (props?.brineLeaseData?.brineLeaseHolds?.[0]?.extensionOptions?.length > 0) {
            setExtensionOptions(props.brineLeaseData.brineLeaseHolds[0].extensionOptions);
        }
    }, [props.brineLeaseData]);

    const getOptions = (type: string, item: string = '') => {
        if (props.measurementTypes?.length > 0) {
            return props.measurementTypes
                .filter((mt) => mt.description === type)
                .map((option) => {
                    if (type === 'Fee' && option.name === 'Per Item') {
                        return { value: option.id, label: `Per ${item}` };
                    }
                    return { value: option.id, label: option.name };
                });
        }
        return [];
    };

    const handleTotals = () => {
        let rep = props.getValues();
        let netAcres = props.totalNet ? props.totalNet : 0;

        let primaryRentalFeeTypeId = parseInt(rep.brineLeaseHolds[0].primaryRentalFeeTypeId, 10);
        let primaryRentalAmount = parseFloat(rep.brineLeaseHolds[0].primaryRentalAmount);
        if (!isNaN(primaryRentalFeeTypeId) && !isNaN(primaryRentalAmount)) {
            let primaryRentalTotal = props.calculateTotal(primaryRentalFeeTypeId, primaryRentalAmount, netAcres, props.measurementTypes);
            props.setValue('brineLeaseHolds[0].primaryRentalTotal', primaryRentalTotal);
        }

        let optionFeeTypeId = parseInt(rep.brineLeaseHolds[0].optionFeeTypeId, 10);
        let optionAmount = parseFloat(rep.brineLeaseHolds[0].optionAmount);
        if (!isNaN(optionFeeTypeId) && !isNaN(optionAmount)) {
            let totalRent = props.calculateTotal(optionFeeTypeId, optionAmount, netAcres, props.measurementTypes);
            props.setValue('brineLeaseHolds[0].optionTotal', totalRent);
        }
    };

    // const displayClauses = () => {
    //     let clauseRows: Array<Array<IndexReferenceType>> = [[]];
    //     let rowIndex = 0;

    //     for (let i = 0; i < props.provisionalClauses.length; i++) {
    //         if (clauseRows[rowIndex].length < 8) {
    //             clauseRows[rowIndex].push(props.provisionalClauses[i]);
    //         } else {
    //             clauseRows.push([]);
    //             rowIndex++;
    //         }
    //     }

    //     return clauseRows.map((cr, index) => {
    //         return (
    //             <div className="form-row" key={`provisionClause-${index + 1}`}>
    //                 {cr.map((pc: IndexReferenceType, rIndex: number) => {
    //                     let currentIndex = (index * 8) + (rIndex);
    //                     return (
    //                         <ProvisionClause
    //                             label={pc.name}
    //                             formPrefix={`brineLeaseHolds[0].provisionLeaseClauses[${currentIndex}]`}
    //                             descriptionRequired={true}
    //                             register={props.register}
    //                             errors={props.errors}
    //                             key={`provisionClause-${index}.${rIndex + 1}`}
    //                             style={{width: '20rem'}}
    //                         />
    //                     );
    //                 })}
    //             </div>
    //         );
    //     });
    // };

    const onAddOption = () => {
        let ref = props.getValues();
        let optionLimit = ref.brineLeaseHolds[0].extensionOptionLimit;

        if (isNaN(Number(optionLimit))) {
            window.alert('Option limit must have a value!');
        } else if (optionLimit <= extensionOptions.length) {
            window.alert('Maximum extension options reached!');
        } else {
            let optionList = [...extensionOptions];
            let newOption = new ExtensionOption();
            optionList.push(newOption);
            setExtensionOptions(optionList);
        }
    };

    return (
        <div>
            <div style={{ margin: '1rem' }}>
                <div style={{ height: '100%', gap: '1rem' }}>
                    <div id="formContent">
                        <div>
                            <div>
                                <div style={{ marginBottom: '2rem' }}>
                                    <RHFLegend title="Contract Terms" />

                                    <div hidden={true}>
                                        <RHFInputBox
                                            label=""
                                            name="brineLeaseHolds[0].id"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="brineLeaseHolds[0].brineLeaseId"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="brineLeaseHolds[0].projectId"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="brineLeaseHolds[0].number"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                        <RHFInputBox
                                            label=""
                                            name="brineLeaseHolds[0].contractLookupId"
                                            register={props.register}
                                            type="number"
                                            disabled={true}
                                            errors={props.errors}
                                        />
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFInputBox
                                                label="Extension Option Limit"
                                                name="brineLeaseHolds[0].extensionOptionLimit"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '33%' }}
                                                style={{width: '100%'}}
                                            />
                                            <RHFInputBox
                                                rules={{ required: 'field required' }}
                                                type="date"
                                                name="leaseDate"
                                                label="Lease Date"
                                                register={props.register}
                                                errors={props.errors}
                                                isRequired={true}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '33%' }}
                                                style={{width: '100%'}}
                                            />
                                            <RHFInputBox
                                                rules={{ required: 'field required' }}
                                                type="date"
                                                name="effectiveDate"
                                                label="Effective Date"
                                                register={props.register}
                                                errors={props.errors}
                                                isRequired={true}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '33%' }}
                                                style={{width: '100%'}}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ margin: 'auto 2rem' }}>
                                        <div className="form-row">
                                            <RHFInputBox
                                                label="Primary Rental Term"
                                                name="brineLeaseHolds[0].primaryRentalTerm"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '20%' }}
                                                style={{width: '100%'}}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="brineLeaseHolds[0].primaryUnitTypeId"
                                                options={getOptions('Time')}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '20%' }}
                                                style={{width: '100%'}}
                                            />
                                            <RHFInputBox
                                                label="Rental Amount"
                                                name="brineLeaseHolds[0].primaryRentalAmount"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                onChange={handleTotals}
                                                step={0.0001}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '20%' }}
                                                style={{width: '100%'}}
                                            />
                                            <RHFSelect
                                                label=" "
                                                name="brineLeaseHolds[0].primaryRentalFeeTypeId"
                                                options={getOptions('Fee', 'acre')}
                                                onChange={handleTotals}
                                                register={props.register}
                                                errors={props.errors}
                                                disabled={props.isInHanded}
                                                bodyStyle={{ width: '20%' }}
                                                style={{width: '100%'}}
                                            />
                                            <RHFInputBox
                                                label="Rental Total"
                                                name="brineLeaseHolds[0].primaryRentalTotal"
                                                register={props.register}
                                                type="number"
                                                errors={props.errors}
                                                disabled={true}
                                                step={0.0001}
                                                bodyStyle={{ width: '20%' }}
                                                style={{width: '100%'}}
                                            />
                                        </div>

                                        {extensionOptions?.length > 0 && (
                                            <ExtensionOptionList
                                                extensionOptions={extensionOptions}
                                                measurementTypes={props.measurementTypes}
                                                namePrefix="brineLeaseHolds[0].extensionOptions"
                                                netAcres={props.totalNet}
                                                calculateTotals={true}
                                                calculateTotal={props.calculateTotal}
                                                getValues={props.getValues}
                                                setValue={props.setValue}
                                                register={props.register}
                                                errors={props.errors}
                                            />
                                        )}

                                        <div className="form-row">
                                            <Button text="Add Option" onClick={onAddOption} size="small" intent="primary" />
                                        </div>
                                    </div>
                                </div>
                                {/* <div style={{ marginBottom: '2rem' }}>
                                    <RHFLegend title="Provisions" />

                                    <div style={{ margin: 'auto 2rem' }}>
                                        {props.provisionalClauses && (
                                            displayClauses()
                                        )}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrineLeaseGeneration;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/BrineLeaseComponents/BrineLeaseGeneration.tsx